// Human-readable registration status for the stage number stored in the database.

const startupStatuses = {
    '-1': 'Declined',
    0: 'Step 1 in progress',
    1: 'Step 1 – pending review',
    2: 'Step 2 in progress',
    3: 'Step 2 – pending review',
    4: 'Waiting for NDA (old in-app NDA)',
    5: 'Waiting for NDA',
    6: 'Live',
};

const investorStatuses = {
    '-1': 'Declined',
    0: 'Step 1 in progress',
    1: 'Step 1 – pending review',
    2: 'Step 2 in progress',
    3: 'Step 2 – pending review',
    4: 'Approved',
};

export function startupStatus(stage) {
    return startupStatuses[parseInt(stage, 10)] || `Stage ${stage}`;
}

export function investorStatus(stage) {
    return investorStatuses[parseInt(stage, 10)] || `Stage ${stage}`;
}
